import { registerTaskHandler } from "./webWorker.js";
import loaderTask from "./loaderTask.js";
//import { default as version } from "../version.js";

// TODO: Not sure if this is necessary, but we probably need it for deflate in dicomParser

// register our task
registerTaskHandler(loaderTask);

const ImageLoaderWebWorker = {
  registerTaskHandler
  //version
};

//export { registerTaskHandler, version };
export { registerTaskHandler };

export default ImageLoaderWebWorker;